module.exports = __webpack_public_path__ + "img/pay_failed.8c082d40.png";